import OvernightToggle from "@/components/dailylogs/OvernightToggle";
import { ChatsCircle } from "@phosphor-icons/react";
import { useState } from "react";
import AppHeader from "@/components/AppHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { WhatsAppSettings } from "@/components/dailylogs/WhatsAppSettings";
import { OverviewTab, ActivityTab, MediaTab } from "@/components/dailylogs/DailyLogsTabs";
import { ReportsTab } from "@/components/dailylogs/ReportsTab";
import { SyncStatusWidget } from "@/components/dailylogs/SyncStatusWidget";
import { StampingToggle } from "@/components/dailylogs/StampingToggle";

export default function DailyLogsPage() {
  const [tab, setTab] = useState("overview");
  return (
    <div className="min-h-screen bg-[#f5f7fb]" data-testid="dailylogs-page">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 space-y-5">
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2 pt-1">
            <ChatsCircle size={24} weight="bold" className="text-[#327de3]" />
            <h1 className="text-2xl font-bold text-slate-900 tracking-tight" data-testid="dailylogs-title">Daily Logs</h1>
          </div>
          <div className="flex items-start gap-3 flex-wrap justify-end">
            <StampingToggle />
            <OvernightToggle />
            <SyncStatusWidget onOpenSettings={() => setTab("settings")} />
          </div>
        </div>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="flex-wrap h-auto" data-testid="dailylogs-tabs">
            <TabsTrigger value="overview" data-testid="dl-tab-overview">Overview</TabsTrigger>
            <TabsTrigger value="activity" data-testid="dl-tab-activity">Activity</TabsTrigger>
            <TabsTrigger value="media" data-testid="dl-tab-media">Media</TabsTrigger>
            <TabsTrigger value="reports" data-testid="dl-tab-reports">Reports</TabsTrigger>
            <TabsTrigger value="settings" data-testid="dl-tab-settings">WhatsApp Settings</TabsTrigger>
          </TabsList>
          <TabsContent value="overview" className="mt-4"><OverviewTab /></TabsContent>
          <TabsContent value="activity" className="mt-4"><ActivityTab /></TabsContent>
          <TabsContent value="media" className="mt-4"><MediaTab /></TabsContent>
          <TabsContent value="reports" className="mt-4">
            <ReportsTab />
          </TabsContent>
          <TabsContent value="settings" className="mt-4"><WhatsAppSettings /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
